import { Component, Input, OnInit } from '@angular/core';
import { IndicationDefinition, IndicationGroup } from '@app/models/indication';
import { ControlTypeEnum, SelectionsModel } from '@app/models/selections-model';
import { SharedService } from '@app/services/shared.service';
import { VennHealthHelpers } from '@app/shared/vennHealthHelpers';
import { first, skip, asapScheduler } from 'rxjs';

@Component({
  selector: 'app-age',
  templateUrl: './age.component.html',
  styleUrls: ['./age.component.css']
})
export class AgeComponent implements OnInit {

  @Input() indication: IndicationDefinition;
  
  allIndications: IndicationGroup[] = [];
  defaultRange: [number, number] = [0, 80]
  public selectedAgeRange: [number, number] = Object.assign([], this.defaultRange);
  public min = 0;
  public max = 80;
  public largeStep = 5;
  public smallStep = 1;

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    // only called first time to setup form and update selected filters via shared service
    this.sharedService.allIndications.pipe(first()).subscribe(data => {
      if (data) {
        this.allIndications = data;
        this.setIndicationSelections();
      }
    });

    // called everytime after the first time
    this.sharedService.allIndications.pipe(skip(1)).subscribe(data => {
      if (data) {
        this.allIndications = data;
      }
    });

    this.sharedService.activeSavedFilters.subscribe(data => {
      if (data) {
        const loadedIndication = VennHealthHelpers.getCurrentIndicationFromIndicationGroupJson(this.indication, this.allIndications);
        this.indication.selections = loadedIndication.selections;
        this.indication.selected = loadedIndication.selected;

        this.setIndicationSelections();
      }
    });
  }

  setIndicationSelections() {
    if (this.indication.selected && this.indication.selections.length > 0) {
      asapScheduler.schedule(() => {
        if (this.indication.selected && this.indication.selections.length > 0) {
          this.selectedAgeRange = this.indication.selections[0].selectionValue;
        }
        this.updateSelections();
      });
    } else {
      this.setDefaults();
    }
  }

  setDefaults() {
    this.selectedAgeRange = Object.assign([], this.defaultRange);
    this.updateSelections();
  }

  getSelectedRangeDisplayValue(): string {
    let display = `${this.selectedAgeRange[0]} - ${this.selectedAgeRange[1]}`;
    if (this.selectedAgeRange[0] === this.selectedAgeRange[1]) {
      display = this.selectedAgeRange[0].toString();
    }
    return display;
  }

  updateSelections(): void {
    const currentSelection: SelectionsModel = {
      indicationName: this.indication.name,
      controlName: "age",
      controlType: ControlTypeEnum.RANGE_SLIDER,
      controlDisplayName: "Age",
      order: 1,
      selectionValue: this.selectedAgeRange,
      selectionDisplayName: this.getSelectedRangeDisplayValue()
    };
    this.indication.selections = [currentSelection];
    const currentIndicationGroup = VennHealthHelpers.getIndicationGroup(this.indication);
    const matchingGroupIndex = this.allIndications.findIndex(i => i.name === currentIndicationGroup.name);
    const matchingIndicationIndex = this.allIndications[matchingGroupIndex].indications.findIndex(i => i.name === this.indication.name);
    this.allIndications[matchingGroupIndex].indications[matchingIndicationIndex] = this.indication;
    this.sharedService.setAllIndications(this.allIndications);
  }

}
